<template>
  <b-toast
    v-if="showToast"
    toast-class="conditions-toast"
    variant="warning"
    visible
    no-auto-hide
    no-close-button
    solid
    :title="$t('views.conditions.conditions_updated_title')"
  >
    <dl>
      <template v-for="conditions in unacceptedConditionsUpdates">
        <dt :key="`title-${conditions}`">{{ conditions | date }}</dt>
        <dd :key="`description-${conditions}`">
          <!-- eslint-disable-next-line vue/no-v-html-->
          <div v-html="$t(`views.conditions.updates.${conditions}.text`)" />

          <a
            v-if="
              $te(`views.conditions.updates.${conditions}.extended_text`) &&
              $te(`views.conditions.updates.${conditions}.extended_text_link`) &&
              $te(`views.conditions.updates.${conditions}.extended_text_modal_title`)
            "
            v-b-modal="`link-to-extended-text-${conditions}`"
            href="#"
          >
            {{ $t(`views.conditions.updates.${conditions}.extended_text_link`) }}
          </a>

          <b-modal
            :id="`link-to-extended-text-${conditions}`"
            hide-footer
            :title="$t(`views.conditions.updates.${conditions}.extended_text_modal_title`)"
          >
            <!-- eslint-disable-next-line vue/no-v-html-->
            <div v-html="$t(`views.conditions.updates.${conditions}.extended_text`)" />
          </b-modal>

          <a
            v-if="$te(`views.conditions.updates.${conditions}.link`)"
            :href="$t(`views.conditions.updates.${conditions}.link`)"
            >{{ $t("views.conditions.link") }}</a
          >
        </dd>
      </template>
    </dl>

    <div class="d-flex justify-content-between">
      <div>
        <icon-button icon="check2-square" :onclick="acceptConditions" variant="success" size="sm">
          {{ $t("views.conditions.accept_updates_button") }}
        </icon-button>
      </div>
      <icon-button
        variant="link"
        size="sm"
        class="text-muted align-self-end"
        to="/profile/account#deactivate"
      >
        {{ $t("views.conditions.unregister_link") }}
      </icon-button>
    </div>
  </b-toast>
</template>

<script>
import IconButton from "@/components/shared/IconButton.vue";
import conditionsTranslations from "@/locales/fr/views/Conditions.json";
import { post } from "@/requests/server";

export default {
  name: "ConditionsUpdatedToast",
  components: { IconButton },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    currentAcceptationDate() {
      return this.$dayjs(this.$store.state.user.conditions_accepted_at);
    },
    showToast() {
      // Avoid showing the toast on the conditions page, which would make it unreadable on mobile.
      if (this.$route.name === "conditions") {
        return false;
      }

      // Avoid showing the toast on the registration page, as this is where
      // accepting the conditions is first requested.
      if ((this.$route.name ?? "").startsWith("register")) {
        return false;
      }

      // FOUC if disconnecting while registering
      if (this.$route.name === "login") {
        return false;
      }

      if (!this.$store.state.loaded || !this.$store.state.user || !this.mostRecentUpdate) {
        return false;
      }

      return (
        !this.currentAcceptationDate.isValid() ||
        this.currentAcceptationDate.isBefore(this.mostRecentUpdate)
      );
    },
    mostRecentUpdate() {
      return this.pastConditionsUpdates.at(-1);
    },
    unacceptedConditionsUpdates() {
      if (!this.currentAcceptationDate.isValid()) {
        return this.pastConditionsUpdates;
      }

      return this.pastConditionsUpdates.filter((d) => this.currentAcceptationDate.isBefore(d));
    },
    pastConditionsUpdates() {
      const today = this.$dayjs();
      return Object.keys(conditionsTranslations.views.conditions.updates)
        .sort()
        .filter((d) => today.isAfter(d));
    },
  },

  methods: {
    async acceptConditions() {
      this.loading = true;
      await post("/acceptConditions", null, {
        notifications: {
          action: this.$t("views.conditions.notifications.accept.action"),
        },
        cleanupCallback: () => (this.loading = false),
      });
      await this.$store.dispatch("loadUser");
      this.$store.commit("addNotification", {
        title: this.$t("views.conditions.notifications.accept.title"),
        content: this.$t("views.conditions.notifications.accept.success"),
        variant: "success",
      });
    },
  },
};
</script>

<style lang="scss">
.conditions-toast {
  max-height: calc(100vh - 1rem);
  overflow: auto !important;
  z-index: 1000;

  .toast-body {
    max-height: calc(100vh - 1rem - 2rem);
    overflow: auto;
  }
}
</style>
